import {MatPasswordStrengthModule} from '@angular-material-extensions/password-strength';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatBottomSheetModule, MatSliderModule} from '@angular/material';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MainComponent} from './components/main/main.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {MsalModule} from '@azure/msal-angular';
import {PublicClientApplication} from '@azure/msal-browser';
import {MdePopoverModule} from '@material-extended/mde';
import * as Hammer from 'hammerjs';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {ChartsModule} from 'ng2-charts';
import {NgxGaugeModule} from 'ngx-gauge';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {QuillModule} from 'ngx-quill';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsSummaryComponent} from './components/admin/forms-summary/forms-summary.component';
import {LogDetailsComponent} from './components/admin/logs/log-details/log-details.component';
import {LogsComponent} from './components/admin/logs/logs.component';
import {ReportsSummaryComponent} from './components/admin/reports-summary/reports-summary.component';
import {AnnouncementPageComponent} from './components/announcement-page/announcement-page.component';
import {AuthStepComponent} from './components/consents/consent-form/auth-step/auth-step.component';
import {ConsentFormComponent} from './components/consents/consent-form/consent-form.component';
import {CustomFormDisplayComponent} from './components/custom-form-display/custom-form-display.component';
import {
    CustomFormParentDisplayComponent
} from './components/custom-form-parent-display/custom-form-parent-display.component';
import {AuthDialogComponent} from './components/dialogs/auth-dialog/auth-dialog.component';
import {ConsentPrintDialogComponent} from './components/dialogs/consent-print-dialog/consent-print-dialog.component';
import {EmailInfoDialogComponent} from './components/dialogs/email-info-dialog/email-info-dialog.component';
import {GeneralEmailComponent} from './components/dialogs/general-email/general-email.component';
import {PrivacyDialogComponent} from './components/dialogs/privacy-dialog/privacy-dialog.component';
import {FeaturesSectionComponent} from './components/features-section/features-section.component';
import {AnnouncementsComponent} from './components/home/announcements/announcements.component';
import {ChildrenConsentsComponent} from './components/home/children-consents/children-consents.component';
import {CompletedConsentsComponent} from './components/home/completed-consents/completed-consents.component';
import {FeaturesComponent} from './components/home/features/features.component';
import {GreetingComponent} from './components/home/greeting/greeting.component';
import {HomeComponent} from './components/home/home.component';
import {CenterComponent} from './components/home/homeComponents/center/center.component';
import {
    HomeMobileChildAssignedFormsComponent
} from './components/home/homeComponents/home-mobile-child-assigned-forms/home-mobile-child-assigned-forms.component';
import {LeftSideComponent} from './components/home/homeComponents/left-side/left-side.component';
import {MobileHistoryComponent} from './components/home/homeComponents/mobile-history/mobile-history.component';
import {MobileSearchComponent} from './components/home/homeComponents/mobile-search/mobile-search.component';
import {RightSideComponent} from './components/home/homeComponents/right-side/right-side.component';
import {MyChildrenComponent} from './components/home/my-children/my-children.component';
import {NotificationMessageComponent} from './components/home/notification-message/notification-message.component';
import {
    NotificationsAnnouncementsDialogComponent
} from './components/home/notifications-announcements-dialog/notifications-announcements-dialog.component';
import {
    AffirmationCardTemplateComponent
} from './components/home/parent-affirmations/affirmation-card-template/affirmation-card-template.component';
import {
    CompleteAffirmationDialogComponent
} from './components/home/parent-affirmations/complete-affirmation-dialog/complete-affirmation-dialog.component';
import {ParentAffirmationsComponent} from './components/home/parent-affirmations/parent-affirmations.component';
import {InitializeFormComponent} from './components/initialize-form/initialize-form.component';
import {LoginAttemptsComponent} from './components/login-attempts/login-attempts.component';
import {LoginComponent} from './components/login/login.component';
import {MyAffirmationsComponent} from './components/my-affirmations/my-affirmations.component';
import {
    AffirmationReportDetailsComponent
} from './components/reports/affirmation-report-details/affirmation-report-details.component';
import {
    ReportAffirmationDetailsTableComponent
} from './components/reports/affirmation-report-details/report-affirmation-details-table/report-affirmation-details-table.component';
import {AnnouncementsReportComponent} from './components/reports/announcements-report/announcements-report.component';
import {CollegeEnrollmentsComponent} from './components/reports/college-enrollments/college-enrollments.component';
import {
    CustomFormParentCompletedComponent
} from './components/reports/custom-form-parent-reports/custom-form-parent-completed/custom-form-parent-completed.component';
import {
    CustomFormParentReportsComponent
} from './components/reports/custom-form-parent-reports/custom-form-parent-reports.component';
import {
    CustomFormCompletedComponent
} from './components/reports/custom-form-reports/custom-form-completed/custom-form-completed.component';
import {
    CustomFormsHistoryDetailsDialogComponent
} from './components/reports/custom-form-reports/custom-form-completed/custom-forms-history-details-dialog/custom-forms-history-details-dialog.component';
import {
    CustomFormRemindersDialogComponent
} from './components/reports/custom-form-reports/custom-form-reminders-dialog/custom-form-reminders-dialog.component';
import {CustomFormReportsComponent} from './components/reports/custom-form-reports/custom-form-reports.component';
import {
    ReportDetailsSideInfoComponent
} from './components/reports/report-details-side-info/report-details-side-info.component';
import {ReportDetailsTableComponent} from './components/reports/report-details-table/report-details-table.component';
import {BarChartComponent} from './components/reports/report-details/bar-chart/bar-chart.component';
import {ReportDetailsComponent} from './components/reports/report-details/report-details.component';
import {ReportsComponent} from './components/reports/reports.component';
import {
    ActivitiesDialogComponent
} from './components/settings/affirmations/activities-dialog/activities-dialog.component';
import {
    ActivitiesLevelsDialogComponent
} from './components/settings/affirmations/activities-levels-dialog/activities-levels-dialog.component';
import {AffirmationsComponent} from './components/settings/affirmations/affirmations.component';
import {
    AssignLevelsToActivityComponent
} from './components/settings/affirmations/assign-levels-to-activity/assign-levels-to-activity.component';
import {
    CreateActivityDialogComponent
} from './components/settings/affirmations/create-activity-dialog/create-activity-dialog.component';
import {CollegeManagementComponent} from './components/settings/college-management/college-management.component';

// tslint:disable-next-line:max-line-length
import {
    ConsentQuestionManagementComponent
} from './components/settings/consent-question-management/consent-question-management.component';
import {
    AddOptionsDialogComponent
} from './components/settings/custom-form-creator/add-options-dialog/add-options-dialog.component';
import {CustomFormCreatorComponent} from './components/settings/custom-form-creator/custom-form-creator.component';
import {EmailLogsComponent} from './components/settings/email-logs/email-logs.component';
import {FormCreatorComponent} from './components/settings/form-creator/form-creator.component';
import {AffirmationCardComponent} from './components/settings/forms/affirmation-card/affirmation-card.component';
import {FormCardComponent} from './components/settings/forms/form-card/form-card.component';
import {FormsComponent} from './components/settings/forms/forms.component';
import {StudentsDialogComponent} from './components/settings/forms/students-dialog/students-dialog.component';
import {
    ParentInfoDialogComponent
} from './components/settings/parents-list/parent-info-dialog/parent-info-dialog.component';
import {ParentsListComponent} from './components/settings/parents-list/parents-list.component';
import {
    ManagementDialogComponent
} from './components/settings/role-action-management/management-dialog/management-dialog.component';
import {
    RoleActionManagementComponent
} from './components/settings/role-action-management/role-action-management.component';
import {SettingsComponent} from './components/settings/settings.component';
import {
    FormUsersAssignmentComponent
} from './components/settings/staff/form-users-assignment/form-users-assignment.component';
import {StaffComponent} from './components/settings/staff/staff.component';
import {FormAssignmentComponent} from './components/settings/students-list/form-assignment/form-assignment.component';
import {StudentsListComponent} from './components/settings/students-list/students-list.component';
import {DisplayComponent} from './components/settings/temp-custom-form-creator/display/display.component';
import {
    FormPropertiesDialogComponent
} from './components/settings/temp-custom-form-creator/form-properties-dialog/form-properties-dialog.component';
import {OptionsComponent} from './components/settings/temp-custom-form-creator/options/options.component';
import {
    TempCustomFormCreatorComponent
} from './components/settings/temp-custom-form-creator/temp-custom-form-creator.component';
import {
    AiFormCreatorComponent
} from './components/settings/ai-form-creator/ai-form-creator.component';
import {UserConfirmationComponent} from './components/settings/user-confirmation/user-confirmation.component';
import {UserSettingsComponent} from './components/settings/user-settings/user-settings.component';
import {AnnouncementsDialogComponent} from './components/shared/announcements-dialog/announcements-dialog.component';
import {AnnouncementsDisplayComponent} from './components/shared/announcements/announcements-display.component';
import {ChildInfoComponent} from './components/shared/child-info/child-info.component';
import {ConfirmDialogComponent} from './components/shared/confirm-dialog/confirm-dialog.component';
import {FormSuccessComponent} from './components/shared/form-success/form-success.component';
import {HeaderLayoutComponent} from './components/shared/header-layout/header-layout.component';
import {LoadingComponent} from './components/shared/loading/loading.component';
import {MessageComponent} from './components/shared/message/message.component';
import {MyMessagesDialogComponent} from './components/shared/my-messages-dialog/my-messages-dialog.component';
import {NavigationDialogComponent} from './components/shared/navigation-dialog/navigation-dialog.component';
import {PageHeaderComponent} from './components/shared/page-header/page-header.component';
import {
    ReportReminderDialogComponent
} from './components/shared/report-reminder-dialog/report-reminder-dialog.component';
import {
    SaveQueryDialogComponent
} from './components/shared/search-dialog/save-query-dialog/save-query-dialog.component';
import {SearchDialogComponent} from './components/shared/search-dialog/search-dialog.component';
import {SkeletonLoadingComponent} from './components/shared/skeleton-loading/skeleton-loading.component';
import {
    AuthStepValidationComponent
} from './components/shared/user-info/auth-step-validation/auth-step-validation.component';
import {UserInfoComponent} from './components/shared/user-info/user-info.component';
import {
    UserInteractionDialogComponent
} from './components/shared/user-interaction-dialog/user-interaction-dialog.component';
import {InterceptService} from './interceptors/intercept.service';
import {AvailableConsentsComponent} from './components/home/mobileLayout/available-consents/available-consents.component';
import {
    SortConsentBottomSheetComponent
} from './components/home/mobileLayout/sort-consent-bottom-sheet/sort-consent-bottom-sheet.component';
import {ParentConsentsComponent} from './components/home/mobileLayout/parent-consents/parent-consents.component';
import {ChildHistoryConsentsComponent} from './components/home/mobileLayout/child-history-consents/child-history-consents.component';
import {ParentPersonalMessagesComponent} from './components/home/mobileLayout/parent-personal-messages/parent-personal-messages.component';

// making hammer config (3)
class MyHammerConfig extends HammerGestureConfig {
    overrides = {
        swipe: {direction: Hammer.DIRECTION_ALL},
    } as any;
}

import {TextEditorComponent} from './components/shared/text-editor/text-editor.component';
import { SendSmsDialogComponent } from './components/shared/send-sms-dialog/send-sms-dialog.component';
import { SmsLogsComponent } from './components/settings/sms-logs/sms-logs.component';
import { ParentStudentRegistrationComponent } from './components/parent-student-registration/parent-student-registration.component';
import { MsOfficeConnectionComponent } from './components/parent-student-registration/ms-office-connection/ms-office-connection.component';
import { InitializeParentComponent } from './components/parent-student-registration/initialize-parent/initialize-parent.component';
import { PublicFormDisplayComponent } from './components/public-form-display/public-form-display.component';
import { PublicReportComponent } from './components/reports/public-report/public-report.component';
import { StudentFormCardsComponent } from './components/home/homeComponents/center/student-form-cards/student-form-cards.component';
import { ResumesComponent } from './components/resumes/resumes/resumes.component';
import { ResumesTableComponent } from './components/resumes/resumes/resumes-table/resumes-table.component';
import { ResumesQuestionsComponent } from './components/resumes/resumes/resumes-questions/resumes-questions.component';
import { ResumesSupplementaryAnswersComponent } from './components/resumes/resumes/resumes-supplementary-answers/resumes-supplementary-answers.component';
import { ResumesEditorComponent } from './components/resumes/resumes/resumes-editor/resumes-editor.component';
import {DxDataGridModule, DxHtmlEditorModule} from 'devextreme-angular';
import { CreateFieldDialogComponent } from './components/resumes/create-field-dialog/create-field-dialog.component';
import { GridViewComponent } from './components/resumes/resumes/resumes-editor/grid-view/grid-view.component';
import {MatGridListModule} from '@angular/material/grid-list';
import { AddRowDialogComponent } from './components/resumes/resumes/resumes-editor/grid-view/add-row-dialog/add-row-dialog.component';
import { FormControlComponent } from './components/resumes/resumes/resumes-editor/grid-view/form-control/form-control.component';
import { CreateResumeFieldComponent } from './components/resumes/resumes/resumes-questions/create-resume-field/create-resume-field.component';
import { ResumesEditorSettingsDialogComponent } from './components/resumes/resumes/resumes-editor/resumes-editor-settings-dialog/resumes-editor-settings-dialog.component';
import { FormTemplatesComponent } from './components/resumes/resumes/resumes-editor/form-templates/form-templates.component';
import { ExtremeEditorComponent } from './components/shared/extreme-editor/extreme-editor.component';
import { ResumesEditorSettingsComponent } from './components/resumes/resumes/resumes-editor/resumes-editor-settings/resumes-editor-settings.component';
import { ResumeReportsComponent } from './components/reports/resume-reports/resume-reports.component';
import { ResumeReportDetailsComponent } from './components/reports/resume-reports/resume-report-details/resume-report-details.component';
import { ResumeFormComponent } from './components/resumes/resume-form/resume-form.component';

const quillConfig = {
    table: true,
    clipboard: {
        matchVisual: true
    },
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        ['table', 'column-left', 'column-right', 'row-above', 'row-below', 'row-remove', 'column-remove'],
        ['link', 'image'],                         // link and image, video
    ]
};
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        AuthDialogComponent,
        PrivacyDialogComponent,
        HeaderLayoutComponent,
        FormCreatorComponent,
        HomeComponent,
        SettingsComponent,
        NavigationDialogComponent,
        ConsentFormComponent,
        FormsComponent,
        ParentsListComponent,
        StudentsListComponent,
        ConfirmDialogComponent,
        FormAssignmentComponent,
        RoleActionManagementComponent,
        ManagementDialogComponent,
        GreetingComponent,
        NotificationMessageComponent,
        FeaturesComponent,
        ChildrenConsentsComponent,
        LoadingComponent,
        CompletedConsentsComponent,
        ReportsComponent,
        AuthStepComponent,
        ConsentQuestionManagementComponent,
        ConfirmDialogComponent,
        FeaturesSectionComponent,
        PageHeaderComponent,
        ReportDetailsComponent,
        ReportDetailsTableComponent,
        BarChartComponent,
        EmailInfoDialogComponent,
        ConsentPrintDialogComponent,
        CollegeManagementComponent,
        FormsSummaryComponent,
        ReportsSummaryComponent,
        LogsComponent,
        LogDetailsComponent,
        InitializeFormComponent,
        UserInfoComponent,
        ChildInfoComponent,
        AuthStepValidationComponent,
        UserSettingsComponent,
        AnnouncementsDialogComponent,
        AnnouncementsDisplayComponent,
        AnnouncementsComponent,
        SearchDialogComponent,
        SaveQueryDialogComponent,
        ParentInfoDialogComponent,
        AffirmationsComponent,
        CreateActivityDialogComponent,
        ActivitiesDialogComponent,
        ActivitiesLevelsDialogComponent,
        AssignLevelsToActivityComponent,
        AffirmationCardComponent,
        FormCardComponent,
        ParentAffirmationsComponent,
        AffirmationCardTemplateComponent,
        CompleteAffirmationDialogComponent,
        MyAffirmationsComponent,
        CollegeEnrollmentsComponent,
        AffirmationReportDetailsComponent,
        AnnouncementPageComponent,
        StudentsDialogComponent,
        ReportAffirmationDetailsTableComponent,
        ReportDetailsSideInfoComponent,
        NotificationsAnnouncementsDialogComponent,
        MyChildrenComponent,
        UserInteractionDialogComponent,
        LeftSideComponent,
        RightSideComponent,
        CenterComponent,
        GeneralEmailComponent,
        UserConfirmationComponent,
        MyMessagesDialogComponent,
        MessageComponent,
        AnnouncementsReportComponent,
        CustomFormCreatorComponent,
        AddOptionsDialogComponent,
        CustomFormDisplayComponent,
        CustomFormReportsComponent,
        CustomFormParentReportsComponent,
        CustomFormCompletedComponent,
        CustomFormsHistoryDetailsDialogComponent,
        FormSuccessComponent,
        TempCustomFormCreatorComponent,
        AiFormCreatorComponent,
        OptionsComponent,
        DisplayComponent,
        FormPropertiesDialogComponent,
        HomeMobileChildAssignedFormsComponent,
        MobileSearchComponent,
        MobileHistoryComponent,
        LoginAttemptsComponent,
        ReportReminderDialogComponent,
        EmailLogsComponent,
        CustomFormRemindersDialogComponent,
        CustomFormParentDisplayComponent,
        CustomFormParentCompletedComponent,
        StaffComponent,
        FormUsersAssignmentComponent,
        SkeletonLoadingComponent,
        MyMessagesDialogComponent,
        AvailableConsentsComponent,
        SortConsentBottomSheetComponent,
        ParentConsentsComponent,
        ChildHistoryConsentsComponent,
        ParentPersonalMessagesComponent,
        TextEditorComponent,
        SendSmsDialogComponent,
        SmsLogsComponent,
        ParentStudentRegistrationComponent,
        MsOfficeConnectionComponent,
        InitializeParentComponent,
        PublicFormDisplayComponent,
        PublicReportComponent,
        StudentFormCardsComponent,
        ResumesComponent,
        ResumesTableComponent,
        ResumesQuestionsComponent,
        ResumesSupplementaryAnswersComponent,
        ResumesEditorComponent,
        CreateFieldDialogComponent,
        GridViewComponent,
        AddRowDialogComponent,
        FormControlComponent,
        CreateResumeFieldComponent,
        ResumesEditorSettingsDialogComponent,
        FormTemplatesComponent,
        ExtremeEditorComponent,
        ResumesEditorSettingsComponent,
        ResumeReportsComponent,
        ResumeReportDetailsComponent,
        ResumeFormComponent,
    ],
    imports: [
        MatGridListModule,
        MatCardModule,
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: '093920a6-77f2-4a10-9766-f38ab3ba7f3a', // Application (client) ID from the app registration
                authority: 'https://login.microsoftonline.com/organizations', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
                redirectUri: 'https://staging-protypa-eapply.ysoft.gr'// This is your redirect URI
            },
            cache: {
                cacheLocation: 'localStorage',
                storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
            }
        }), null, null),
        MdePopoverModule,
        HammerModule,
        ChartsModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatBottomSheetModule,
        HttpClientModule,
        MatSnackBarModule,
        MatDialogModule,
        FormsModule,
        MatToolbarModule,
        MatCardModule,
        MatListModule,
        MatSidenavModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: true}),
        NgxSkeletonLoaderModule.forRoot(),
        MatMenuModule,
        MatBadgeModule,
        MatTabsModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgMultiSelectDropDownModule.forRoot(),
        NgxMatSelectSearchModule,
        QuillModule.forRoot({
            placeholder: '',
            modules: {
                clipboard: {
                    matchVisual: true
                },
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{header: 1}, {header: 2}],               // custom button values
                    [{list: 'ordered'}, {list: 'bullet'}],
                    [{script: 'sub'}, {script: 'super'}],      // superscript/subscript
                    [{indent: '-1'}, {indent: '+1'}],          // outdent/indent
                    [{direction: 'rtl'}],                         // text direction

                    [{size: ['small', false, 'large', 'huge']}],  // custom dropdown
                    [{header: [1, 2, 3, 4, 5, 6, false]}],

                    [{color: []}, {background: []}],          // dropdown with defaults from theme
                    [{font: []}],
                    [{align: []}],

                    ['clean'],                                         // remove formatting button
                    ['link', 'image'],                         // link and image, video
                ]
            }
        }),
        MatCheckboxModule,
        MatTooltipModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatStepperModule,
        MatRadioModule,
        MatDatepickerModule,
        NgxGaugeModule,
        MatChipsModule,
        MatPasswordStrengthModule,
        MatAutocompleteModule,
        MatExpansionModule,
        DragDropModule,
        MatRippleModule,
        ScrollingModule,
        DxDataGridModule,
        DxHtmlEditorModule,
        MatSliderModule,
        MatDividerModule
    ],
    providers: [
        MatDatepickerModule,
        ConfirmDialogComponent,
        AnnouncementsComponent,
        {
            provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
        },
        {provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig},

        {provide: MAT_DATE_LOCALE, useValue: 'el-GR'},
        {
            provide: HTTP_INTERCEPTORS, useClass: InterceptService, multi: true
        },
        {
            provide: LocationStrategy, useClass: HashLocationStrategy
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
